import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";

import { stripePromise } from "./stripe-config";
import { ActivityProvider } from "./state/ActivityProvider";
import App from "./App";

import "./theme.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* 🌐 Routeur global de l'application */}
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {/* 📊 Contexte activité */}
      <ActivityProvider>
        {/* 💳 Contexte Stripe pour les paiements */}
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </ActivityProvider>
    </BrowserRouter>
  </React.StrictMode>
);